<template>
  <div class="water-delivery-form">
    <validation-observer
      ref="formValidation"
    >
      <!-- Delivery Address Section -->
      <validation-provider
        v-slot="{ errors }"
        :name="$t('field.address')"
        rules="required"
      >
        <b-form-group
          :label="$t('field.deliveryAddress')"
          :state="errors.length === 0 ? null : false"
          class="mb-2"
        >
          <b-form-textarea
            v-model="formData.address"
            :rows="2"
            :state="errors.length === 0 ? null : false"
            :placeholder="$t('placeholder.enterAddress')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>

      <!-- Type of Bottle Section -->
      <validation-provider
        v-slot="{ errors }"
        :name="$t('field.bottleType')"
        rules="required"
      >
        <b-form-group
          :label="$t('field.typeOfBottle')"
          :state="errors.length === 0 ? null : false"
          class="mb-2"
        >
          <b-form-radio-group
            v-model="formData.bottleSize"
            :options="[
              { text: $t('field.bottledWaterLarge'), value: 3},
              { text: $t('field.bottledWaterSmall'), value: 1 }
            ]"
            :state="errors.length === 0 ? null : false"
          />
          <div class="d-flex align-items-center mt-2">
            <b-form-spinbutton
              v-model="formData.qty"
              min="1"
              :state="errors.length === 0 ? null : false"
            />
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>

      <!-- Charge Type Section -->
      <validation-provider
        v-slot="{ errors }"
        :name="$t('field.chargeType')"
        rules="required"
      >
        <b-form-group
          :label="$t('field.chargeType')"
          :state="errors.length === 0 ? null : false"
          class="mb-2"
        >
          <b-form-radio-group
            v-model="formData.chargeType"
            :options="[
              { text: $t('field.singlePayment'), value: 'single' }
            ]"
            :state="errors.length === 0 ? null : false"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>

      <!-- Service Time Section -->
      <validation-provider
        v-slot="{ errors }"
        :name="$t('field.scheduleType')"
        rules="required"
      >
        <b-form-group
          :label="$t('field.serviceTime')"
          :state="errors.length === 0 ? null : false"
          class="mb-2"
        >
          <b-form-radio-group
            v-model="formData.scheduleType"
            :options="[
              { text: $t('field.immediately'), value: 1 },
              { text: $t('field.customTime'), value: 2 }
            ]"
            :state="errors.length === 0 ? null : false"
          />
          <n-date-time-picker
            v-if="formData.scheduleType === 2"
            v-model="formData.scheduleDate"
            :state="errors.length === 0 ? null : false"
            :disable-before-today="true"
            :disable-after-today="false"
            class="mt-2"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormRadioGroup,
  BFormTextarea,
  BFormSpinbutton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import NDateTimePicker from '@/components/NDateTimePicker.vue'

export default {
  name: 'WaterDeliveryForm',

  components: {
    BFormGroup,
    BFormRadioGroup,
    BFormTextarea,
    BFormSpinbutton,
    ValidationProvider,
    ValidationObserver,
    NDateTimePicker,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      formData: {
        scheduleType: 1,
        scheduleDate: '',
        addressType: 0,
        address: '',
        subscriptionType: 0,
        subscriptionPlanId: null,
        bottleSize: 1,
        qty: 1,
        chargeType: 'single',
      },
    }
  },

  watch: {
    value: {
      handler(newValue) {
        if (newValue && JSON.stringify(newValue) !== JSON.stringify(this.formData)) {
          this.formData = {
            scheduleType: newValue.scheduleType ?? 1,
            scheduleDate: newValue.scheduleDate ?? '',
            addressType: newValue.addressType ?? 0,
            address: newValue.address ?? '',
            subscriptionType: newValue.subscriptionType ?? 0,
            subscriptionPlanId: newValue.subscriptionPlanId ?? null,
            bottleSize: newValue.bottleSize ?? 1,
            qty: newValue.qty ?? 1,
            chargeType: newValue.chargeType ?? 'single',
          }
        }
      },
      immediate: true,
      deep: true,
    },
    formData: {
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
          this.$emit('input', { ...newValue })
        }
      },
      deep: true,
    },
  },

  methods: {
    async validate() {
      if (this.$refs.formValidation) {
        return this.$refs.formValidation.validate()
      }
      return false
    },

    reset() {
      this.formData = {
        scheduleType: 1,
        scheduleDate: null,
        addressType: 0,
        address: '',
        subscriptionType: 0,
        subscriptionPlanId: null,
        bottleSize: 1,
        qty: 1,
        chargeType: 'single',
      }
      if (this.$refs.formValidation) {
        this.$refs.formValidation.reset()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.water-delivery-form {
  .form-group:last-child {
    margin-bottom: 0;
  }
}
</style>
